import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { HelperService } from "@app/main/core/services/helper.service";
import { GameSettingsService } from "../../game-settings.service";
import { environment } from "@env/environment";

@Component({
  selector: "app-cash-prize-image-upload",
  templateUrl: "./cash-prize-image-upload.component.html",
  styleUrls: ["./cash-prize-image-upload.component.scss"],
})
export class CashPrizeImageUploadComponent implements OnInit {
  @Input() prizeIndex: number;
  s3BucketUrl = environment.s3BucketUrl;

  cashPrizeImageFile: any;
  cashPrizeImage: any;
  description: string = "";

  constructor(
    private helperService: HelperService,
    private domSanitizer: DomSanitizer,
    private gameSettingsService: GameSettingsService
  ) {}

  ngOnInit() {
    // prizeEntry may be undefined if this component ever mounts before the
    // dialog's own ngOnInit has created the winPattern[prizeIndex] slot.
    const prizeEntry =
      this.gameSettingsService.winPattern &&
      this.gameSettingsService.winPattern[this.prizeIndex];

    if (prizeEntry && prizeEntry.image1) {
      this.cashPrizeImage = prizeEntry.image1.image;
      this.description = prizeEntry.image1.description || "";
    } else {
      // cashPrizeImage (the fallback resource fetched by the route resolver)
      // may itself be undefined/absent, e.g. a prize that has never had a
      // cash-prize image and no default resource is configured.
      const defaultCashPrizeImage = this.gameSettingsService.cashPrizeImage
        ? this.gameSettingsService.cashPrizeImage.value
        : undefined;

      if (prizeEntry) {
        prizeEntry.image1 = {
          image: defaultCashPrizeImage,
          description: "",
        };
      }
      this.cashPrizeImage = defaultCashPrizeImage;
    }
  }

  updateDescription() {
    if (this.gameSettingsService.winPattern[this.prizeIndex].image1) {
      this.gameSettingsService.winPattern[
        this.prizeIndex
      ].image1.description = this.description;
    } else {
      // Initialize if somehow missing, though ngOnInit matches should prevent this
      this.gameSettingsService.winPattern[this.prizeIndex].image1 = {
        description: this.description,
      };
    }
  }

  uploadImage($event, shouldCompress: boolean = true) {
    if ($event && $event.target && $event.target.files.length !== 0) {
      const file = $event.target.files[0];

      const handleImageUpdate = (blob: Blob, base64?: string) => {
        this.cashPrizeImageFile = blob;
        this.cashPrizeImage = base64
          ? this.sanitizeUrl(base64)
          : this.sanitizeUrl(blob);

        const currentImage1 =
          this.gameSettingsService.winPattern[this.prizeIndex].image1 || {};
        this.gameSettingsService.winPattern[this.prizeIndex].image1 = {
          ...currentImage1,
          image: this.cashPrizeImage,
          file: this.cashPrizeImageFile,
        };
      };

      if (shouldCompress) {
        this.helperService
          .compressImage(file)
          .then((result) => {
            handleImageUpdate(result.originalFile, result.compressedBase64);
          })
          .catch((error) => {
            console.error("Error compressing image:", error);
          });
      } else {
        handleImageUpdate(file);
      }
    }
  }

  sanitizeUrl(fileOrBase64: Blob | string): SafeUrl {
    if (typeof fileOrBase64 === "string") {
      return this.domSanitizer.bypassSecurityTrustUrl(fileOrBase64);
    }

    const objectUrl = URL.createObjectURL(fileOrBase64);
    return this.domSanitizer.bypassSecurityTrustUrl(objectUrl);
  }

  getImageSrc(): SafeUrl | string | undefined {
    if (this.cashPrizeImage) {
      if (this.cashPrizeImageFile !== undefined) {
        return this.cashPrizeImage;
      } else {
        return this.s3BucketUrl + this.cashPrizeImage;
      }
    }

    return undefined; // <-- Let Angular skip rendering if there's no valid image
  }
}
